<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'edit'">
      <div class="card">
        <div class="card-body">
          <em-entity-edit-form ref="emEntityEditForm" :entity="modelName" @changeEntityAttribute="changeEntityAttribute"
                               :$_em-custom-vuex-mixin_entity="entityState"></em-entity-edit-form>
        </div>
        <!--param编辑-->
        <div>
          <label class="control-label">
            <span class="lbl-obg">*</span>
            {{ $t('report.template.runtimeParam') }}:
          </label>
          <table class="table table-striped table-hover">
            <thead>
            <tr>
              <td>
                <div scope="col">
                  {{ $t("report.template.placeholder") }}
                </div>
              </td>
              <td>
                <div scope="col">
                  {{ $t("report.template.paramName") }}
                </div>
              </td>
              <td>
                <div scope="col">
                  {{ $t("report.template.paramType") }}
                </div>
              </td>
              <td>
                <div scope="col">
                  {{ $t("report.template.paramValue") }}
                </div>
              </td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="col in runConfig" v-bind:key="col.paramName">
              <td>
                <div scope="col">
                  {{ col.paramName }}
                </div>
              </td>
              <td>
                <div scope="col">
                  <input class="form-control" v-model="col.paramDesc">
                </div>
              </td>
              <td>
                <div scope="col">
                  <select class="form-control" v-model="col.paramType">
                    <option selected="selected">{{ $t("report.template.time") }}</option>
                    <option>{{ $t("report.template.text") }}</option>
                  </select>
                </div>
              </td>
              <td>
                <div v-if="col.paramType == 'Text Type' || col.paramType == '文本类型'" scope="col">
                  <b-form-input v-model="col.paramValue"></b-form-input>
                </div>
                <div v-if="col.paramType == 'Time Type' || col.paramType == '时间类型'" scope="col">
                  <select class="form-control" v-model="col.paramValue">
                    <option selected="selected" value="thisWeekStart">{{ $t("report.template.thisWeekStart") }}</option>
                    <option value="thisWeekEnd">{{ $t("report.template.thisWeekEnd") }}</option>
                    <option value="lastWeekStart">{{ $t("report.template.lastWeekStart") }}</option>
                    <option value="lastWeekEnd">{{ $t("report.template.lastWeekEnd") }}</option>
                    <option value="thisMonthStart">{{ $t("report.template.thisMonthStart") }}</option>
                    <option value="thisMonthEnd">{{ $t("report.template.thisMonthEnd") }}</option>
                    <option value="lastMonthStart">{{ $t("report.template.lastMonthStart") }}</option>
                    <option value="lastMonthEnd">{{ $t("report.template.lastMonthEnd") }}</option>
                    <option value="thisQuarterStart">{{ $t("report.template.thisQuarterStart") }}</option>
                    <option value="thisQuarterEnd">{{ $t("report.template.thisQuarterEnd") }}</option>
                    <option value="lastQuarterStart">{{ $t("report.template.lastQuarterStart") }}</option>
                    <option value="lastQuarterEnd">{{ $t("report.template.lastQuarterEnd") }}</option>
                  </select>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Author lgq
// Date 2022-02-23 13:53:32

import emCommonEditMixin from "@/mixin/em/common/edit";
import _ from "lodash";

export default {
  name: "emSicCustomizedDiagramPieceCdpEditView",
  mixins: [emCommonEditMixin],
  data() {
    return {
      runConfig: null
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    entityState() {
      return this.$route.query.hasOwnProperty('entityState') ? this.$route.query.entityState : 'entity';
    },
    cdpParamConf: {
      get() {
        let tempJson = this.$store.state[this.modelName].entity.cdpParamConf ? JSON.parse(this.$store.state[this.modelName].entity.cdpParamConf) : [];
        return tempJson;
      },
      set(value) {
        this.$store.commit(`${this.modelName}/setCdpParamConf`, JSON.stringify(value))
      }
    },
    cdpProperties: {
      get() {
        // this.changeCdpProperties()
        return JSON.parse(this.$store.state[this.modelName].entity.cdpProperties)
      },
      set(value) {
        this.$store.commit(`${this.modelName}/setCdpProperties`, JSON.stringify(value))
      }
    }
  },
  watch:{
    'runConfig': {
      handler (newVal) {
        if(newVal != null) {
          this.cdpParamConf = newVal
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    changeCdpProperties() {
      console.log("changeCdpProperties",cdpPropertiesJson,this.cdpParamConf)
      this.runConfig = this.runConfig == null ? (this.cdpParamConf == null ? [] : this.cdpParamConf) : this.runConfig
      let cdpPropertiesJson = JSON.parse(this.$store.state[this.modelName].entity.cdpProperties)
      // let cdpPropertiesJson = JSON.parse(newValue)
      try {
        let sqlString = cdpPropertiesJson["sql"] + cdpPropertiesJson["queryParam"];
        let tmpList = [];
        console.log("match ocupy,queryParam is", cdpPropertiesJson["queryParam"])
        console.log("match ocupy,sqlString is", sqlString)
        let ocupyParamPatt = /\s+\?[0-9]+/g;
        let ocupyParamList = sqlString.match(ocupyParamPatt);
        if (ocupyParamList !== null) {
          for (let ocupyParam of ocupyParamList) {
            ocupyParam = _.trim(ocupyParam)
            let currentParam = this.checkOcupyParamConstains(this.runConfig, ocupyParam);
            if (currentParam == null)
              tmpList.push({paramName: ocupyParam, paramType: "text", paramDesc: "", paramValue: ""})
            else {
              if (this.checkOcupyParamConstains(tmpList, ocupyParam) == null)
                tmpList.push(currentParam)
            }
          }
        }
        this.runConfig = tmpList;
      } catch
          (err) {
        console.log(err)
      }
    },
    checkOcupyParamConstains(dataList, ocupyParam) {
      for(let item of dataList) {
        if(item["paramName"] === ocupyParam)
          return item;
      }
      return null;
    },
    changeEntityAttribute(key,value){
      console.log("changeEntityAttribute",key,value)
      if(key === 'cdpProperties'){
        this.changeCdpProperties()
      }
    }
  },
  mounted() {
    this.changeCdpProperties()
  }
}
;
</script>